import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyLogistics from '../components/addEditCopyLogistics/index.vue';

var EditLogisticsAgentPage = function (_super) {
  __extends(EditLogisticsAgentPage, _super);

  function EditLogisticsAgentPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditLogisticsAgentPage = __decorate([Component({
    components: {
      AddEditCopyLogistics: AddEditCopyLogistics
    }
  })], EditLogisticsAgentPage);
  return EditLogisticsAgentPage;
}(Vue);

export default EditLogisticsAgentPage;